<template>
  <nav v-if="!activation" class="navbar is-fixed-top">
    <div class="navbar-brand">
      <a role="button" class="navbar-burger burger" :class="{ 'is-active': isActive }" data-target="navMenu" @click="toggleNav">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div id="navMenu" class="navbar-menu" :class="{ 'is-active': isActive }">

      <template v-if="isLoggedIn">
        <router-link :to="{ name: 'home' }" class="navbar-item">Home</router-link>
        <router-link :to="{ name: 'info' }" class="navbar-item">Info</router-link>
        <router-link :to="{ name: 'contact' }" class="navbar-item">Contact</router-link>
      </template>

      <template v-if="isLoggedIn">
        <router-link v-show="isAdmin" :to="{ name: 'items' }" class="navbar-item">Items</router-link>
        <router-link :to="{ name: 'products' }" class="navbar-item" v-show="isAdmin || isSupplier">Producten</router-link>
        <router-link :to="{ name: 'knowledges' }" class="navbar-item" v-show="isAdmin || isSupplier">Kennis</router-link>
        <router-link v-show="isAdmin" :to="{ name: 'suppliers' }" class="navbar-item">Leveranciers</router-link>
        <router-link v-show="isAdmin" :to="{ name: 'users' }" class="navbar-item">Gebruikers</router-link>
        <router-link :to="{ name: 'account' }" class="navbar-item">Account</router-link>
        <a v-show="isLoggedIn" href="#" class="navbar-item" @click="signOut">Afmelden</a>
      </template>

      <template v-else class="is-pulled-right">
        <router-link :to="{ name: 'signin' }" class="navbar-item">Aanmelden</router-link>
        <!-- <router-link :to="{ name: 'signup' }" class="navbar-item">Account maken</router-link> -->
      </template>
    </div>
  </nav>
</template>

<script>
  export default {
    data () {
      return {
        isActive: false
      }
    },
    computed: {
      isLoggedIn () {
        return this.$store.getters.isLoggedIn
      },
      isAdmin () {
        return this.$store.getters.isAdmin
      },
      isSupplier () {
        return this.$store.getters.isSupplier
      },
      activation () {
        return this.$route.path.includes('activeren')
      }
    },
    methods: {
      toggleNav () {
        this.isActive = !this.isActive;
      },
      signOut () {
        this.$store.dispatch('signOut')
      }
    }
  }
</script>

<style>
  .navbar-burger {
    margin-left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/nav/NavBar.vue